import {Country} from 'src/app/domain/core/country.model';
import {VehicleBrand} from 'src/app/domain/core/vehicle-brand.model';
import {LegalEntitiesData} from 'src/app/domain/data/legal-entities.data';
import {environment} from 'src/environments/environment';

export type CountryBrand = 'ToyotaGermany' | 'ToyotaAustria' | 'LexusGermany' | 'LexusAustria'

export interface LegalEntityValues {
  name: string
  department: string
  city: string
  phone: string
  email: string
}

export class LegalEntity {
  name: string
  department: string
  city: string
  phone: string
  email: string
  countryBrand: CountryBrand;
  constructor(
    public country: Country,
    public vehicleBrand: VehicleBrand
  ) {
    this.countryBrand = (vehicleBrand.nameForCountryBrand + country.nameForCountryBrand) as CountryBrand
    const values = LegalEntitiesData[this.countryBrand]
    this.name = values.name
    this.department = values.department
    this.city = values.city
    this.phone = values.phone
    this.email = values.email
  }

  static get ToyotaGermany(): LegalEntity {
    return new LegalEntity(Country.DE, VehicleBrand.TOYOTA)
  }

  static from(brand: VehicleBrand, country: Country): LegalEntity {
    return new LegalEntity(country, brand)
  }

  static fromCountryBrand(countryBrand: CountryBrand): LegalEntity {
    switch (countryBrand) {
      case 'ToyotaGermany':
        return LegalEntity.from(VehicleBrand.TOYOTA, Country.DE);
      case 'ToyotaAustria':
        return LegalEntity.from(VehicleBrand.TOYOTA, Country.AT);
      case 'LexusGermany':
        return LegalEntity.from(VehicleBrand.LEXUS, Country.DE);
      case 'LexusAustria':
        return LegalEntity.from(VehicleBrand.LEXUS, Country.AT);
    }
  }

  consentLink(consentVersion: string) {
    if (!consentVersion) {
      consentVersion = this.country.defaultConsentVersion;
    }
    let url = environment.eweUrl;
    if (this.vehicleBrand.isLexus()) {
      url = url.replace(/\/(toyota)\//, '/lexus/');
    }
    return url.replace('{consentVersion}', consentVersion);
  }

  dsiLink(consentVersion: string) {
    if (!consentVersion) {
      consentVersion = this.country.defaultConsentVersion;
    }
    let url = environment.dsiUrl;
    if (this.vehicleBrand.isLexus()) {
      url = url.replace(/\/(toyota)\//, '/lexus/');
    }
    return url.replace('{consentVersion}', consentVersion);
  }
}
